// extracted by mini-css-extract-plugin
export default {"all":"NotFound_all__sDnRh","center":"NotFound_center__m1-09","fade-in":"NotFound_fade-in__hiwjf","err-404":"NotFound_err-404__EqN+V"};